import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { I18N_NS } from "Config/i18n";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface NotFoundPlaceholderProps extends WithTranslation {
  resource?: string;
  text?: string;
  icon?: IconName;
  style?: React.CSSProperties;
}

export const NotFoundPlaceholder = withTranslation(I18N_NS.GENERAL)(
  class extends React.Component<NotFoundPlaceholderProps> {
    render() {
      const { t, resource, text, icon } = this.props;
      const name = resource ? resource : "data";
      return (
        <div className="nf-placeholder">
          <FontAwesomeIcon icon={["far", icon || "ban"] as IconProp} size="2x" />
          <div className="nf-placeholder--text">{text ? text : name && t("No {{name}} available", { name })}</div>
        </div>
      );
    }
  }
);
